"use client";

import { FeatureHighlight, SecondaryLink } from "@/components/shared/public";
import { Separator } from "@/components/ui/separator";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { individualExample2 } from "../../../../public/images/floor-plans";
import { whatCosts } from "../../../../public/images/individuel-floor-plan";

const PriceInfo = () => {
  const t = useTranslations("individualFp.priceInfo");

  return (
    <div className="gs--page-column py-16">
      <FeatureHighlight
        src={whatCosts}
        alt={"Icon Kosteninformationen individueller Grundriss"}
        title={t("title")}
        text={t("text")}
        className="lg:w-3/4"
      />
      <div className="flex flex-col items-center gap-10 md:flex-row">
        <div className="flex flex-col gap-10">
          <div className="flex flex-col gap-10">
            <Separator />
            <p className="text-ring">{t("explanation")}</p>
            <Separator />
          </div>
          <div className="flex items-center">
            <SecondaryLink href={"/grundriss-designs"} title={t("link")} />
          </div>
        </div>

        <Image
          src={individualExample2}
          alt={"Individuelle Grundrisse Beispiel"}
          width={400}
          height={400}
          loading="lazy"
          className="h-auto max-h-[500px] w-auto"
        />
      </div>
    </div>
  );
};

export default PriceInfo;
